<app-modal 
  [open]="true" 
  [actions]="actions" 
  [highlightPrimaryAction]="true"
  (handleAction)="handleAction($event)">
  <input #colorPicker [(colorPicker)]="color" [cpToggle]="true" [cpDialogDisplay]="'inline'" />
</app-modal>